import script from "./BulkSigningPortal.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkSigningPortal.vue?vue&type=script&setup=true&lang=js"

import "./BulkSigningPortal.vue?vue&type=style&index=0&id=ba09fcac&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba09fcac"]])

export default __exports__